import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import {
  formatMoney
} from "../../utils/formatMoney";

import {
  motion
} from "framer-motion";

import api from "../../api";

function PersonnelDetail() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [data, setData] =
    useState(null);

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    api
      .get(
        `/personnel/${id}`
      )
      .then((res) =>
        setData(
          res.data
        )
      )
      .catch((err) =>
        console.error(err)
      );

  }, [id]);

  // =====================
  // LOADING
  // =====================

  if (!data) {

    return (
      <p className="p-4 md:p-6">
        Chargement...
      </p>
    );

  }

  // =====================
  // RENDER
  // =====================

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 20
      }}
      animate={{
        opacity: 1,
        y: 0
      }}
      transition={{
        duration: 0.4
      }}
      className="p-3 md:p-6 space-y-5 min-h-[100dvh] bg-gray-100"
    >

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

        <h2 className="text-2xl md:text-3xl font-bold">
          Fiche Personnel
        </h2>

        <button
          onClick={() =>
            navigate(-1)
          }
          className="bg-gray-200 hover:bg-gray-300 transition px-4 py-3 rounded-xl"
        >
          ⬅️ Retour
        </button>

      </div>

      {/* INFOS */}
      <motion.div
        whileHover={{
          scale: 1.01
        }}
        className="bg-white p-4 md:p-6 rounded-2xl shadow grid grid-cols-1 md:grid-cols-3 gap-4"
      >

        <div>

          <p className="text-sm text-gray-500">
            Nom
          </p>

          <p className="font-semibold text-lg break-words">
            {
              data.personnel.nom
            }{" "}
            {
              data.personnel.prenom
            }
          </p>

        </div>

        <div>

          <p className="text-sm text-gray-500">
            Fonction
          </p>

          <p className="font-semibold break-words">
            {
              data.personnel.fonction
            }
          </p>

        </div>

        <div>

          <p className="text-sm text-gray-500">
            Salaire
          </p>

          <p className="font-semibold text-green-600">
            {formatMoney(
              data.personnel
                .salaire_base
            )}
          </p>

        </div>

      </motion.div>

      {/* HISTORIQUE */}
      <div className="bg-white rounded-2xl shadow overflow-hidden">

        <div className="p-4 border-b font-semibold">
          Historique des paiements
        </div>

        {/* MOBILE */}
        <div className="md:hidden p-3 space-y-3">

          {data.salaires
            .length ===
            0 && (

            <p className="text-gray-400 text-center py-4">
              Aucun paiement
            </p>

          )}

          {data.salaires.map(
            (s) => (

              <motion.div
                key={s.id}
                whileHover={{
                  scale: 1.01
                }}
                className="border rounded-2xl p-4 shadow-sm"
              >

                <p className="text-sm text-gray-500">
                  Date
                </p>

                <p className="font-semibold">
                  {new Date(
                    s.date_paiement
                  ).toLocaleDateString()}
                </p>

                <p className="text-sm text-gray-500 mt-3">
                  Montant
                </p>

                <p className="font-bold text-indigo-600 text-lg">
                  {formatMoney(
                    s.montant
                  )}
                </p>

              </motion.div>

            )
          )}

        </div>

        {/* DESKTOP */}
        <div className="hidden md:block overflow-x-auto">

          <table className="min-w-full text-sm">

            <thead className="bg-gray-100">

              <tr>

                <th className="px-4 py-3 text-left">
                  Date
                </th>

                <th className="px-4 py-3 text-left">
                  Montant
                </th>

              </tr>

            </thead>

            <tbody>

              {data.salaires
                .length ===
                0 ? (

                <tr>

                  <td
                    colSpan="2"
                    className="px-4 py-6 text-center text-gray-400"
                  >
                    Aucun paiement
                  </td>

                </tr>

              ) : (

                data.salaires.map(
                  (s) => (

                    <tr
                      key={s.id}
                      className="border-t hover:bg-gray-50 transition"
                    >

                      <td className="px-4 py-3">
                        {new Date(
                          s.date_paiement
                        ).toLocaleDateString()}
                      </td>

                      <td className="px-4 py-3 font-semibold text-indigo-600">
                        {formatMoney(
                          s.montant
                        )}
                      </td>

                    </tr>

                  )
                )

              )}

            </tbody>

          </table>

        </div>

      </div>

    </motion.div>
  );
}

export default PersonnelDetail;